import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/payments';

export const paymentsService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  get: (id) => apiClient.get(`${base}/${id}`),
  reconcile: (id) => apiClient.post(`${base}/${id}/reconcile`),
  refund: (id, payload) => apiClient.post(`${base}/${id}/refund`, payload),
  revenue: (params) => apiClient.get(`${base}/revenue`, { params: cleanParams(params) }),
  // Subscriptions
  subscriptions: (params) => apiClient.get('/admin/subscriptions', { params: cleanParams(params) }),
  grant: (userId, payload) => apiClient.post(`/admin/subscriptions/${userId}/grant`, payload),
  revoke: (userId) => apiClient.post(`/admin/subscriptions/${userId}/revoke`),
};

export default paymentsService;
